import { render, staticRenderFns } from "./Profile-User-Password-Regist.vue?vue&type=template&id=457139da&scoped=true&"
import script from "./Profile-User-Password-Regist.vue?vue&type=script&lang=js&"
export * from "./Profile-User-Password-Regist.vue?vue&type=script&lang=js&"
import style0 from "./Profile-User-Password-Regist.vue?vue&type=style&index=0&id=457139da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457139da",
  null
  
)

export default component.exports